import { keepPreviousData, useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { adminApi } from "../../../api-client";
import type { AdminChatMessageFilters } from "../../../admin-api/chat";
import type { ReportStatus, UpdateReportStatus } from "../../../schemas/report";
import { queryKeys } from "../../query-keys";

export function useAdminChatMessages(filters?: AdminChatMessageFilters) {
	return useQuery({
		queryKey: queryKeys.adminChat.list(filters),
		queryFn: () => adminApi.chat.listMessages(filters),
		placeholderData: keepPreviousData,
	});
}

export function useMessageReports(status: ReportStatus | "all" = "open") {
	return useQuery({
		queryKey: queryKeys.messageReports.list(status),
		queryFn: () => adminApi.chat.reports.list(status),
		placeholderData: keepPreviousData,
	});
}

export function useUpdateMessageReportStatus() {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: ({ id, body }: { id: string; body: UpdateReportStatus }) =>
			adminApi.chat.reports.updateStatus(id, body),
		onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.messageReports.all }),
	});
}
